import React from "react";
import { useTranslation } from "react-i18next";

import { ToggleInput } from "@common/toggleInput";
import { Props } from "./types";
import styles from "./styles.scss";

function DetailsToggle({ isToggled, toggle }: Props) {
  const { t } = useTranslation();

  return (
    <label className={styles.detailsToggle} onClick={toggle}>
      <p className={styles.label}>{t("timeSheet.detailsToggle")}</p>
      <ToggleInput isToggled={isToggled} />
    </label>
  );
}

export { DetailsToggle };
